<div class="cycle-detail-container">
  <div class="detail-header" *ngIf="totalItems > 0">
    <span>
      Showing <strong>{{ showingStart }}</strong> to <strong>{{ showingEnd }}</strong> of
      <strong>{{ totalItems }}</strong> test plan(s)
    </span>
  </div>

  <div class="detail-list" *ngIf="totalItems > 0; else emptyState">
    <div
      class="detail-row"
      *ngFor="let row of paginatedRows; trackBy: trackByRowId"
      [class.detail-row--expanded]="row.expanded"
      (click)="toggleExpanded(row)"
      (keydown)="toggleExpanded(row)">

      <div class="row-main">
        <div class="row-left">
          <div class="name-status-wrap">
            <h3 class="plan-name">{{ row.name }}</h3>
            <div>
            <img src="assets/images/virtusa-icons/calender-dark.svg" class="date-icon" alt="Date" />
            <span class="time-value">{{ formatDate(row.startTime) }}</span> -
            <span class="time-value">{{ formatDate(row.endTime) }}</span>
            </div>
          </div>
        </div>

        <div class="row-progress">
          <app-multi-segment-progress-bar
            [segments]="getRowSegments(row)"
            [barHeight]="8"
            [borderRadius]="50">
          </app-multi-segment-progress-bar>

          <div class="progress-legend-custom">
            <span class="legend-item">
              <i class="legend-dot" style="background:#5F2CFF"></i>
              Completed <strong>{{ row.completedCount }}</strong>
            </span>
            <span class="legend-item">
              <i class="legend-dot" style="background:#DED6FF"></i>
              Executing <strong>{{ row.executingCount }}</strong>
            </span>
            <span class="legend-item">
              <i class="legend-dot" style="background:#E8E8E9"></i>
              Pending <strong>{{ row.pendingCount }}</strong>
            </span>
            <span class="legend-sep"></span>
            <span class="legend-item">Total <strong>{{ row.totalCount }}</strong></span>
          </div>
        </div>

        <div class="row-status">
          <app-status-badge [status]="row.status" size="small"></app-status-badge>
        </div>
        
        <div class="row-actions">
         <div class="report-actions">
            <!-- Insights -->
          <button
            class="accello-icon-btn"
            (click)="openInsights(row, $event)"
            aria-label="View Report"
            matTooltip="View Report"
            matTooltipPosition="below">
            <img src="assets/images/virtusa-icons/insight.svg" class="action-icon" alt="Insights" />
          </button>
          <!-- Download -->
          <button
            class="accello-icon-btn"
            (click)="downloadReport(row, $event)"
            aria-label="Download">
            <img src="assets/images/virtusa-icons/download-new.svg" class="action-icon" alt="Download" />
          </button>
         </div>
          <!-- Expand/Collapse -->
          <button
            class="icon-btn icon-btn--toggle"
            (click)="toggleExpanded(row, $event)"
            [attr.aria-label]="row.expanded ? 'Collapse row' : 'Expand row'">
            <img
              *ngIf="!row.expanded"
              src="assets/images/virtusa-icons/add-outline.svg"
              alt="expand" />
            <img
              *ngIf="row.expanded"
              src="assets/images/virtusa-icons/remove-outline.svg"
              alt="collapse" />
          </button>
        </div>
      </div>

      <div class="row-expanded" *ngIf="row.expanded" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <app-zorro-table
          [columns]="testCaseTableColumns"
          [data]="getTestCaseTableRows(row)"
          [options]="defaultTableOptions"
          [hideVerticalBorder]="false"
          (onRowSelect)="onTableRowSelect($event, row)"
          (handleActions)="handleTableActions($event, row)">
        </app-zorro-table>

        <div class="expanded-empty" *ngIf="getTestCaseTableRows(row).length === 0">
          No test cases available for this plan.
        </div>
      </div>
    </div>
  </div>

  <div class="detail-pagination" *ngIf="totalItems > pageSize">
    <nz-pagination
      [nzPageIndex]="currentPage"
      [nzTotal]="totalItems"
      [nzPageSize]="pageSize"
      [nzShowSizeChanger]="false"
      (nzPageIndexChange)="onPageChange($event)">
    </nz-pagination>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">No execution plan details available</div>
  </ng-template>
</div>
